/* eslint-disable max-len */
import React from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { Oval } from  'react-loader-spinner'

export default function ExitModal({isOpen, setIsOpen, handleSave, 
    getButtonText,handleNavigation, loading}) {
    
    
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[99]" onClose={()=>!loading && setIsOpen(false)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-80" />
                </Transition.Child>
                <div className="fixed left-0 top-0 z-[1055] h-full w-full 
                    overflow-y-auto overflow-x-hidden outline-none">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full transform overflow-hidden rounded-[10px]
                                    bg-white text-left align-middle shadow-xl transition-all 
                                    min-[640px]:mx-auto min-[640px]:mt-7 min-[640px]:min-h-[calc(100%-3.5rem)] 
                                    min-[640px]:max-w-[520px]">
                                <button
                                    type="button" id='close-icon'
                                    className="box-content rounded-none border-none absolute top-4 right-4 z-10"
                                    data-te-modal-dismiss
                                    aria-label="Close" onClick={()=>!loading && setIsOpen(false)}>
                                    <img src="/images/CloseButton-modalcontent.svg" alt="img" loading="lazy"/>
                                </button>
                                <div className="relative pt-[50px] pb-[35px]">
                                    <p className="px-4 text-center pb-[12px] leading-normal text-[16px] 
                                    text-[#343434] font-medium" id='Auction Bidders Data' data-testid='confirmationModal'>
                                        Exit Without Saving?</p>
                                    <p className='pr-[71px] pl-[61px] text-center text-[14px] pb-[27px] text-[#A1A1A9] font-medium'>
                                        You are about to leave this editor with unsaved changes. 
                                        Would you like to save these changes before leaving?
                                    </p>
                                    <div className="flex justify-center">
                                        <button 
                                            disabled={loading}
                                            className="px-[31px] py-[12px] border border-[#A1A1A9] 
                                                bg-[#fffff]  text-[#282828] leading-normal hover:bg-[#EFF1F8]
                                                font-medium text-[14px] rounded-[6px]" 
                                            onClick={handleNavigation} data-testid={getButtonText()}>
                                            {getButtonText()}
                                        </button>
                                        <a className='ml-[20px]'>
                                            <button disabled={loading}
                                                className="px-[31px] py-[12px] bg-[#282828]  text-[#FFFFFF] 
                                                disabled:bg-[#D4D4D8] disabled:text-[hsl(240,4%,65%)] hover:bg-[#626465]
                                                leading-normal font-medium text-[14px] rounded-[6px] flex justify-center" 
                                                onClick={async () => { await handleSave(); handleNavigation(); }} data-testid='save'>
                                                Save
                                                {loading && 
                                                <Oval
                                                    height={20}
                                                    width={50}
                                                    color="#FFFFFF"
                                                    wrapperClass=""
                                                    visible={true}
                                                    ariaLabel='oval-loading'
                                                    secondaryColor="#000000"
                                                    strokeWidth={2}
                                                    strokeWidthSecondary={2}
                                                /> }
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}